import customerquickview from "./customer-quickview.html";

const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler = require('../../../../../components/dt/dt-handler')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false

function HTMLselect(detail) {
      const sourceElement = detail.ev?.target || null;

      quickviewHandler.HTMLselect(

            'customer', //database table name****
            'customer-quickview',
            sourceElement, //source, for example AC
            customerquickview,
            htmlQf)

      HTMLwasSelected = true


}/**/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      show: { start: (detail) => { quickviewHandler.show(detail, htmlQf) } },
      hide: { start: (detail) => { quickviewHandler.hide(detail, htmlQf) } },

      getExtraData: { start: (detail) => { getExtraData(detail) } },
}/**/

export async function getExtraData(detail) {
      let result = "";
      const formData = new FormData();
      if (detail.idCustomer) {
            formData.append('idCustomer', detail.idCustomer);
      } else {
            formData.append('idSale', detail.idSale);
      }

      try {
            result = await fetch("./server/php/queries/entityFunction/customer_behaivor.php", {
                  method: "POST",

                  body: formData,
                  credentials: 'same-origin'
            });

            if (!result.ok) throw new Error("Error en la red");

            const resultados = await result.json();
            quickviewHandler.show(detail, htmlQf)
            llenarTablaAverage(resultados.data)
            llenarTablaAgaing(resultados.againg)
      } catch (err) {
            console.error("Error en la petición:", err);
      }
}

function llenarTablaAverage(datos) {

      const columns = [
            { key: 'roi', label: 'ROI', format: 'percent', behavior: true, title: 'roi_title' },
            { key: 'profit', label: 'Revenue', format: 'star', behavior: true, title: 'profit_title' },
            { key: 'payment_speed', label: 'Payment Speed', format: 'star', behavior: true, title: 'payment_speed_title' },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#customer-quickview-behaivor');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function llenarTablaAgaing(datos) {

      const contName = htmlQf.quickviewHTML.querySelector('#customer_quickview_name');
      contName.innerHTML = ""
      contName.innerHTML = datos.customer

      const columns = [
            { key: 'current', label: 'Current', format: 'cash', behavior: false },
            { key: 'total_due_30_days', label: '0-30d', format: 'cash', behavior: false },
            { key: 'total_due_31_to_60_days', label: '31-60d', format: 'cash', behavior: false },
            { key: 'total_due_61_to_90_days', label: '61-90d', format: 'cash', behavior: false },
            { key: 'total_due_over_90_days', label: '90+d', format: 'cash', behavior: false },
            { key: 'total_due', label: 'Total', format: 'cash', behavior: false },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#customer-quickview-report');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}